export default {
  'msn.msnWithoutContainer': {
    field1: 50,
    field4: 550,
    field5: 200,
    field6: 150,
    field7: 600,
  },
}
